import { MapStateToPropsFactory } from "react-redux";
import { ApplicationState } from "@ppb/tbd-store/state/ApplicationState.types";
import { PartialItem } from "@ppb/tbd-store/state/layout/views/PartialItem.types";
import { UserDetails } from "@ppb/tbd-store/state/entities/user-details/UserDetailsState";
import { getUserDetails, getUserJurisdiction } from "@ppb/tbd-store/state/entities/user-details/user-details-selectors";
import { Jurisdiction } from "@ppb/tbd-store/state/constants";

export type StateProps = {
  items: PartialItem[];
  isDesktop?: boolean;
  showTitle: boolean;
};

export type ContainerProps = {
  isDesktop?: boolean;
};

export const makeMapStateToProps: MapStateToPropsFactory<StateProps, ContainerProps, ApplicationState> =
  () =>
  (state: ApplicationState, { isDesktop = true }: ContainerProps): StateProps => {
    const userDetails = <UserDetails>getUserDetails(state);
    const userDetailsJurisdiction = getUserJurisdiction(userDetails);

    const showTitle = !(userDetailsJurisdiction === Jurisdiction.BRAZIL && isDesktop);

    return {
      items: state.layouts.leftSidebar.items,
      isDesktop,
      showTitle,
    };
  };
